import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "../../Style/Testimonial.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { TestiMonialsAPI } from "../../API/CommanApi";

const settings = {
  dots: true, // Enable dots indicator
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  arrows: true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const CustomNextArrow = (props) => {
  const { onClick } = props;
  return (
    <button className="slider_Arrowr_right" onClick={onClick} aria-label="Next">
      <FaChevronRight />
    </button>
  );
};

const CustomPrevArrow = (props) => {
  const { onClick } = props;
  return (
    <button className="slider_Arrowr_left" onClick={onClick} aria-label="Previous">
      <FaChevronLeft />
    </button>
  );
};

const Testimonial = () => {
  const [testimonial, setTestimonial] = useState([]);

  useEffect(() => {
    testmonialdata();
  }, []);

  const testmonialdata = () => {
    TestiMonialsAPI((callback) => {
      setTestimonial(callback?.data?.testimonial_list || []);
    });
  };

  return (
    <div className="RatingSection">
      <div className="container-xxl">
        <div className="testimonial-header text-center">
          <span className="testimonial-pill">Testimonials</span>
          <h3>What Our Clients Say</h3>
           <p>Real stories from clients who trusted our Sydney real estate experts for apartments, rentals, and property management.</p> 
        </div>
        <div className="testimonial-slider-wrapper">
          <Slider
            {...settings}
            nextArrow={<CustomNextArrow />}
            prevArrow={<CustomPrevArrow />}
          >
            {testimonial.map((data, i) => {
              const { name, profile, description, image } = data;
              return (
                <div className="testimonial-slide-padding" key={i}>
                  <div className="card_sec">
                    <div className="quote-icon quote-top">“</div>
                    <div className="client-info">
                      <div className="client-avatar-wrapper">
                        {image ? (
                          <img className="client-avatar-img" src={image} alt={name} />
                        ) : (
                          <div className="avatar-placeholder">
                            {name ? name.charAt(0).toUpperCase() : "C"}
                          </div>
                        )}
                      </div>
                      <div className="client-details">
                        <h5 className="client-name">{name}</h5>
                        <span className="client-role">{profile || "Client"}</span>
                      </div>
                    </div>
                    <p className="slider_content">{description}</p>
                    <div className="quote-icon quote-bottom">”</div>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;

